export const FEATURES = [
  {
    key: "konserter",
    title: "Konserter",
    short: "Hantering av konserter och evenemang.",
    details: [
      "Skapa konserter med datum, lokal och tid",
      "Lokalkostnad och vem som ansvarar för bokningen",
      "Bokningsdatum och status för bokning",
      "Ladda upp och spara bokningsbekräftelse",
      "Övergripande status för konserten",
    ],
    icon: "Music2",
  },
  {
    key: "sektioner",
    title: "Orkestersektioner",
    short: "Administration av stämmor och sektioner.",
    details: [
      "Lägg till musiker i respektive sektion per konsert",
      "Status för varje sektion (Ej klart, Klart, Ej tillämpligt)",
    ],
    icon: "Users",
  },
  {
    key: "inhyrda",
    title: "Inhyrda musiker",
    short: "Vikarier, dirigenter, kör och extramusiker.",
    details: [
      "Dirigent, musiker och kör med egen status",
      "Ladda upp och spara engagemangskontrakt",
      "Kostnad för inhyrda musiker",
    ],
    icon: "Mic2",
  },
  {
    key: "ljud-ljus",
    title: "Ljud & Ljus",
    short: "Teknisk planering och leverantörer.",
    details: [
      "Vilka anlitas för ljud respektive ljus",
      "Status och kostnad för varje leverantör",
    ],
    icon: "Lightbulb",
  },
  {
    key: "transport-hotell",
    title: "Transport & Hotell",
    short: "Reselogistik och boende för orkestern.",
    details: [
      "Resebolag, resor och kostnader",
      "Hotell, rumsfördelning och kostnader",
      "Ladda upp bokningsbekräftelser, biljetter och fakturor",
      "Status (Ej klart, Klart, Ej tillämpligt)",
    ],
    icon: "Plane",
  },
  {
    key: "mat",
    title: "Mat, genrep & konsert",
    short: "Catering till repetitioner och konserter.",
    details: [
      "Leverantör och kostnad för maten",
      "Bekräftelse på beställning",
      "Övriga önskemål och allergier",
      "Status för maten",
    ],
    icon: "UtensilsCrossed",
  },
  {
    key: "reklam",
    title: "Reklam, PR & övrigt",
    short: "Marknadsföring och kringkostnader.",
    details: [
      "Reklam och media per konsert med kostnad",
      "Övriga poster och dess kostnader",
    ],
    icon: "Megaphone",
  },
  {
    key: "arenden",
    title: "Ärendehantering",
    short: "Strukturerad uppföljning av åtgärder.",
    details: [
      "Skapa ärenden och åtgärder per konsert",
      "Ansvarig person och tydlig beskrivning",
      "Deadline och status (Pågående, Klart)",
      "Datum för när åtgärden är avslutad",
    ],
    icon: "ClipboardCheck",
  },
  {
    key: "avtal",
    title: "Avtal",
    short: "Engagemangsavtal för inhyrda musiker.",
    details: [
      "Skapa engagemangsavtal för personer som hyrs in",
      "Ladda upp underskrivet eller godkänt avtal",
      "Lön eller faktura, F-skatt, organisationsnummer",
      "Status för varje upprättat avtal",
    ],
    icon: "FileSignature",
  },
  {
    key: "dokumentarkiv",
    title: "Dokumentarkiv",
    short: "Säker lagring av allt orkestern behöver.",
    details: [
      "Protokoll och årsrapporter",
      "Annonsavtal och sponsoravtal",
      "Ekonomirapporter och övriga dokument",
    ],
    icon: "Archive",
  },
  {
    key: "musiker",
    title: "Musiker & Personregister",
    short: "Komplett databas över medlemmar.",
    details: [
      "Namn, adress och personuppgifter",
      "Kategori (orkestermedlem, vikarie, konsertmästare, dirigent)",
      "Instrument och orkestersektion",
    ],
    icon: "Contact2",
  },
  {
    key: "resurser",
    title: "Resursregister",
    short: "Översikt över allt som krävs för en konsert.",
    details: [
      "Konsertlokal, ljud, ljus, hotell, resebolag, transport",
      "Företagsnamn och kontaktuppgifter",
      "Spara dokument och avtal per resurs",
    ],
    icon: "Library",
  },
  {
    key: "installningar",
    title: "Inställningar",
    short: "Anpassa plattformen efter er orkester.",
    details: [
      "Grunddata (förenings- och företagsuppgifter)",
      "Dokumenttyper och kategorier",
      "Instrument, orkestersektioner och resurskategorier",
    ],
    icon: "Settings2",
  },
  {
    key: "lankar",
    title: "Länkar",
    short: "Snabb tillgång till externa resurser.",
    details: [
      "Relevanta länkar för er verksamhet",
    ],
    links: [
      { label: "STIM", url: "https://www.stim.se/en" },
      { label: "Musikerförbundet", url: "https://www.musikerforbundet.se/" },
      { label: "Skatteverket", url: "https://www.skatteverket.se/" },
    ],
    icon: "Link2",
  },
];
